<template>
  <div class="dashboard-page">
    <!-- Row 1: Stat Cards -->
    <div class="stats-row">
      <div class="stat-card">
        <div class="stat-icon-wrapper">
          <span class="icon">💳</span>
        </div>
        <div class="stat-content">
          <span class="stat-title">Jumlah Transaksi</span>
          <h2 class="stat-value">{{ formattedAmount }}</h2>
          <span class="stat-badge">+1.2% minggu ini</span>
        </div>
      </div>
      
    </div>

  </div>
</template>

<script>
export default {
  name: "Dashboard",
  data() {
    return {
      amount: 0
    }
  },
  computed: {
    formattedAmount() {
      return new Intl.NumberFormat('id-ID').format(this.amount)
    }
  },
  created() {
    fetch(`${this.$apiURL}/v1/count_data_nasabah`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      body: JSON.stringify({
        kode_bank: JSON.parse(localStorage.getItem("user") || "{}").bank.id,
      }),
    })
    .then((res) => res.json())
    .then((result) => {
      this.loading = false;
      this.amount = result
    })
    .catch((err) => {
      this.loading = false;
      console.error("Fetch error:", err);
    });
  },
}
</script>

<style scoped>
.dashboard-page {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* Stat Cards */
.stats-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 20px;
}

.stat-card {
  background: #ffffff;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  border: 1px solid #e2e8f0;
  border-bottom: 4px solid #0b1953;
  box-shadow: 0 4px 12px rgba(11, 25, 83, 0.04);
}

.stat-icon-wrapper {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #0b1953;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 20px;
  flex-shrink: 0;
}

.stat-content {
  display: flex;
  flex-direction: column;
}

.stat-title {
  font-size: 0.85rem;
  color: #64748b;
}

.stat-value {
  font-size: 1.6rem;
  font-weight: 800;
  color: #0b1953;
  margin: 2px 0;
}

.stat-badge {
  font-size: 0.75rem;
  color: #f47b20;
  font-weight: 600;
}

/* Grid Layout Chart + Table */
.main-grid {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 20px;
  align-items: start;
}

@media (max-width: 1024px) {
  .main-grid {
    grid-template-columns: 1fr;
  }
}

.card-box {
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
  padding: 20px;
  overflow: hidden;
}

/* Chart Box */
.chart-box {
  height: 320px;
  display: flex;
  flex-direction: column;
}

.chart-legend {
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  margin-bottom: 20px;
  font-size: 0.85rem;
  color: #64748b;
}

.dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 2px;
  margin-right: 4px;
}
.dot.navy { background-color: #0b1953; }
.dot.yellow { background-color: #ffc107; }

.chart-body {
  flex: 1;
  display: flex;
  align-items: flex-end;
  justify-content: space-around;
  border-bottom: 2px solid #edf2f7;
  padding-bottom: 10px;
}

.bar-column {
  display: flex;
  align-items: flex-end;
  gap: 6px;
  height: 100%;
}

.bar {
  width: 18px;
  border-radius: 4px 4px 0 0;
}
.bar-navy { background-color: #0b1953; }
.bar-yellow { background-color: #ffc107; }

/* Table Box */
.table-box {
  padding: 0;
}

.table-header-bar {
  height: 45px;
  background-color: #0b1953;
  border-radius: 12px 12px 0 0;
}

.dash-table {
  width: 100%;
  border-collapse: collapse;
}

.dash-table th, .dash-table td {
  padding: 12px 16px;
  text-align: left;
  font-size: 0.85rem;
}

.dash-table th {
  color: #64748b;
  font-weight: 600;
  border-bottom: 1px solid #edf2f7;
}

.dash-table td {
  color: #334155;
  border-bottom: 1px solid #f1f5f9;
}
</style>